import { GemsApi_StoneColour } from '@/graphql/api'
import { computed, type ComputedRef, type Ref, toValue } from 'vue'
import { findOrder } from '@/domain/stone/search/findOrder'

const ordered: GemsApi_StoneColour[] = [
    GemsApi_StoneColour.DiamondD,
    GemsApi_StoneColour.DiamondE,
    GemsApi_StoneColour.DiamondF,
    GemsApi_StoneColour.DiamondG,
    GemsApi_StoneColour.DiamondH,
    GemsApi_StoneColour.DiamondI,
    GemsApi_StoneColour.DiamondJ,
    GemsApi_StoneColour.DiamondK,
    GemsApi_StoneColour.DiamondL,
    GemsApi_StoneColour.DiamondM,
] as const

function findColourOrder(code: GemsApi_StoneColour) {
    return findOrder(ordered, code)
}

export function useOrderedColour(
    shapes: Ref<GemsApi_StoneColour[]> | (() => GemsApi_StoneColour[])
): ComputedRef<GemsApi_StoneColour[]> {
    return computed(() => {
        return toValue(shapes).sort(
            (a: GemsApi_StoneColour, b: GemsApi_StoneColour) => {
                const orderA = findColourOrder(a)
                const orderB = findColourOrder(b)

                return orderA - orderB
            }
        )
    })
}
